import { axiosInstanceWebsite } from "../instance";

export interface UserBrand {
  id: string;
  owner_id?: string;
  name: string;
  brandboard_url?: string | null;
  brandboard_image?: string | null;
  logo_url?: string | null;
  logo_dark_url?: string | null;
  logo_light_url?: string | null;
  brand_colors?: Record<string, any>;
  font_family?: string | null;
  font_technical_description?: string | null;
  personality_text?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface UserBrandPayload {
  name: string;
  brandboard_url?: string | null;
  brandboard_image?: string | null;
  logo_url?: string | null;
  logo_image?: string | null;
  logo_dark_url?: string | null;
  logo_dark_image?: string | null;
  logo_light_url?: string | null;
  logo_light_image?: string | null;
  source_images?: string[] | null;
  source_image_urls?: string[] | null;
  brand_colors?: Record<string, any>;
  font_family?: string | null;
  font_technical_description?: string | null;
  personality_text?: string | null;
  auto_generate_metadata?: boolean | null;
}

export const getUserBrands = async (): Promise<UserBrand[]> => {
  const response = await axiosInstanceWebsite.get("/user/brands");
  return Array.isArray(response.data) ? response.data : [];
};

export const createUserBrand = async (payload: UserBrandPayload): Promise<UserBrand> => {
  const response = await axiosInstanceWebsite.post("/user/brands", payload);
  return response.data;
};

export const updateUserBrand = async (id: string, payload: UserBrandPayload): Promise<UserBrand> => {
  const response = await axiosInstanceWebsite.put(`/user/brands/${id}`, payload);
  return response.data;
};

export const deleteUserBrand = async (id: string): Promise<{ deleted: boolean; id: string }> => {
  const response = await axiosInstanceWebsite.delete(`/user/brands/${id}`);
  return response.data;
};
